import { render, staticRenderFns } from "./MenuReportPoints.vue?vue&type=template&id=67988cc4&scoped=true&"
import script from "./MenuReportPoints.vue?vue&type=script&lang=js&"
export * from "./MenuReportPoints.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportPoints.vue?vue&type=style&index=0&id=67988cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67988cc4",
  null
  
)

export default component.exports